/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 *  
 *  Navigation utils
 */

var NavigationUtils = function(){};


/**
 * Static functions
 */


/**
 * Scroll to element by selector
 * @param {string} element
 * @returns {Boolean}
 */
NavigationUtils.scrollToElement = function(element, offset){
	var el = $(element).first();
	if(el){
		var durationMin = 0.5;
		var durationMax = 1.5;
		var durationFactor = 700;

		var elementTop = Math.round(el.offset().top + (!isNaN(offset) ? offset : 0));
		var currentPageTop = $(document).scrollTop();
		var distance = elementTop - currentPageTop;
		var duration = distance / durationFactor;

		// set duration bounds
		duration = Math.max(duration, durationMin);
		duration = Math.min(duration, durationMax);

		$('html, body').stop().animate({scrollTop: elementTop}, duration * 1000, 'swing');
		return true;
	}
	return false;
};


/**
 * Bind scrolling to all links with '.scrollToElement' class
 */
NavigationUtils.initScrollToElementLinks = function(offset) {
	var clickLinks = $('.scrollToElement:not(.scrollToElement-inited)');

	if (clickLinks.length > 0) {
		clickLinks.click(function (event) {
			event.preventDefault();
			var link = $(this);
			var elementSelector = link.data('scrollTarget');
			if (elementSelector) {
				NavigationUtils.scrollToElement(elementSelector, offset);
			}
		});

		// set init flag to existing links
		$('.scrollToElement').addClass('scrollToElement-inited');
	}
};
